<app-customer-conditions-modal [showDefaultConditions]="showDefaultConditions"
  [useDefaultConditions]="useDefaultConditions">
</app-customer-conditions-modal>
